<template>
  <div>
    <Spinner v-if="isLoadingLog" />

    <div class="notification is-info" v-if="gamecamEmailNotFound">No active Gamecam found.</div>

    <div class="notification is-danger" v-if="logLoadError">{{ logLoadError }}</div>

    <div class="panel"
      v-if="gamecamFound">
      <a class="panel-block has-background-grey-dark has-text-light">
        <span class="panel-icon">
          <i
            class="icon-camera has-text-weight-bold has-text-light"
            aria-hidden="true"
          ></i>
        </span>

        <div class="container">
          <span class="is-pulled-left">{{ query.trim() }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";

import {
  LOAD_LOG_FOR_EMAIL,
  GET_EMAIL,
  IS_LOADING_LOG,
  GET_LOG,
  GET_LOG_LOAD_ERROR,
  HAS_EMPTY_LOG_LOAD_RESULT,
  RESET_LOG_STATE
} from "./gamecamStore";

export default {
  name: "GamecamsSearch",
  components: {
    Spinner
  },

  props: {
    query: {
      type: String,
      default: ""
    },

    gamecamStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
    };
  },

  mounted() {
    if (this.$route.name === "gamecamsSearch") {
      // Only reset search when a new search has started
      const invalidateSearchResultsAction = `${this.gamecamStorePath}/${RESET_LOG_STATE}`;
      this.$store.dispatch(invalidateSearchResultsAction);
    }

    this.performSearch();
  },

  methods: {
    performSearch() {
      const email = this.query.trim();
      const loadLogAction = `${this.gamecamStorePath}/${LOAD_LOG_FOR_EMAIL}`;
      this.$store.dispatch(loadLogAction, { email });
    }
  },

  computed: {
    gamecamFound() {
      if (!this.loadedLog) {
        return false;
      }

      return this.loadedLog.length > 0;
    },

    email() {
      const getEmail = `${this.gamecamStorePath}/${GET_EMAIL}`;
      return this.$store.getters[getEmail];
    },

    isLoadingLog() {
      const isLoadingLog = `${this.gamecamStorePath}/${IS_LOADING_LOG}`;
      return this.$store.getters[isLoadingLog];
    },

    loadedLog() {
      const getLog = `${this.gamecamStorePath}/${GET_LOG}`;
      return this.$store.getters[getLog];
    },

    logLoadError() {
      const getLogLoadError = `${this.gamecamStorePath}/${GET_LOG_LOAD_ERROR}`;
      return this.$store.getters[getLogLoadError];
    },

    gamecamEmailNotFound() {
      const hasEmptyLogLoadResult = `${this.gamecamStorePath}/${HAS_EMPTY_LOG_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyLogLoadResult];
    }
  },

  watch: {
    gamecamFound() {
      if (!this.gamecamFound) {
        return;
      }

      const gamecamStorePath = this.gamecamStorePath
      const email = this.email
      this.$router.push({ name: 'gamecamDetails', params: { gamecamStorePath, email }, query: this.$route.query })
    }
  }
}
</script>

<style>

</style>
